/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionCheckboxMarkedCircle: {
  name: 'temp-selection-checkbox-marked-circle';
  data: string;
} = {
  name: 'temp-selection-checkbox-marked-circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm4.768 8.64a1 1 0 1 0-1.536-1.28l-4.3 5.159-2.225-2.226a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.475-.067l5-6Z" fill="currentColor"/></svg>`,
};
